import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, Package, Users, TrendingUp } from "lucide-react";
import api, { formatPrice } from "../../lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/dashboard").then(r => setStats(r.data));
  }, []);

  if (!stats) return <div className="overline animate-pulse">Cargando...</div>;

  const cards = [
    { label: "Ingresos", value: formatPrice(stats.revenue), icon: TrendingUp, key: "revenue" },
    { label: "Pedidos totales", value: stats.total_orders, icon: ShoppingBag, key: "orders" },
    { label: "Clientes", value: stats.total_customers, icon: Users, key: "customers" },
    { label: "Productos", value: stats.total_products, icon: Package, key: "products" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <p className="overline mb-3">Panel de control</p>
      <h1 className="font-heading text-4xl text-ivory mb-10">Dashboard</h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-12">
        {cards.map(c => (
          <div key={c.key} className="bg-graphite border border-smoke p-6" data-testid={`stat-${c.key}`}>
            <div className="flex items-center justify-between mb-4">
              <c.icon className="text-gold" size={20} />
            </div>
            <p className="overline mb-2">{c.label}</p>
            <p className="font-heading text-3xl text-ivory">{c.value}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-graphite border border-smoke p-6">
          <h2 className="font-heading text-xl text-ivory mb-6">Estados de pedidos</h2>
          <div className="space-y-3">
            {Object.entries(stats.orders_by_status).map(([k, v]) => (
              <div key={k} className="flex justify-between items-center pb-3 border-b border-smoke/50">
                <span className="text-sm text-ivory/70 uppercase tracking-wider">{k}</span>
                <span className="text-gold font-heading text-lg">{v}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-graphite border border-smoke p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="font-heading text-xl text-ivory">Pedidos recientes</h2>
            <Link to="/admin/orders" className="text-gold text-xs uppercase tracking-[0.2em] hover:underline">Ver todos</Link>
          </div>
          <div className="space-y-3">
            {stats.recent_orders.map(o => (
              <div key={o.id} className="flex justify-between items-center pb-3 border-b border-smoke/50">
                <div>
                  <p className="text-sm text-ivory">#{o.id.slice(0, 8).toUpperCase()}</p>
                  <p className="text-xs text-ivory/40">{o.shipping_address?.full_name || o.user_email || "Invitado"}</p>
                </div>
                <p className="text-gold font-heading">{formatPrice(o.total)}</p>
              </div>
            ))}
            {stats.recent_orders.length === 0 && <p className="text-sm text-ivory/40">Aún no hay pedidos</p>}
          </div>
        </div>
      </div>
    </div>
  );
}
